import Vue from 'vue'
import Resource from 'vue-resource'

Vue.use(Resource)
let actions = {
  questionnaires: {
    method: 'GET',
    url: '/api/v1/evaluate/questionnaires'
  },
  questionnaire: {
    method: 'GET',
    url: '/api/v1/evaluate{/code}/questionnaire'
  },
  record: {
    method: 'PUT',
    url: '/api/v1/evaluate{/code}/question'
  },
  report: {
    method: 'GET',
    url: '/api/v1/evaluate{/code}/report'
  }
}
export default Vue.resource('/api/v1/evaluate{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/evaluate.js